// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"g3-z","upvote":"h3-z","downvote":"i3-z","numVotes":"j3-z","votesDescription":"k3-z","report":"l3-z","voted":"m3-z","answerVoteBox":"n3-z","justReported":"o3-z"};